<template>
  <v-chip v-if="child" :disabled="true">
    <v-avatar :class="getAssessmentCssClassByAge(child.totalMonthsOld)"><div class="inner">{{ child.totalMonthsOld }}</div></v-avatar>
    {{ child.firstName }} {{ child.lastName }} - {{ $t('LBL.T_MONTHS', {AGE_MTH: child.totalMonthsOld}) }}
  </v-chip>
</template>

<script>
import AssessmentMixin from '@/components/mixins/AssessmentMixin'

export default {
  name: 'ChildClip',
  computed: {
    childMonthsOld () {
      if (this.child.totalMonthsOld) {
        return this.child.totalMonthsOld
      } else if (this.child.birthdate) {
        return this.calcMonthsOld(this.child.birthdate)
      }
      return ''
    }
  },
  data () {
    return {
      introDialog: false,
      addChildDialog: false
    }
  },
  methods: {
    calcMonthsOld: function (birthdateStr) {
      let months = 0

      const todayDate = new Date()
      const birthdate = new Date()
      const dateParts = birthdateStr.split('-')
      birthdate.setFullYear(dateParts[0])
      birthdate.setMonth(dateParts[1] - 1)
      birthdate.setDate(dateParts[2])

      months = (todayDate.getFullYear() - birthdate.getFullYear()) * 12
      months -= birthdate.getMonth() + 1
      months += todayDate.getMonth()
      if (birthdate.getDate() < todayDate.getDate()) {
        months += 1
      }

      return months <= 0 ? 0 : months
    }
  },
  mixins: [
    AssessmentMixin
  ],
  props: {
    child: {
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
.avatar {
  .inner {
    background: #fff;
    width: 20px;
    height: 20px;
    border-radius: 20px;
    line-height: 20px;
    font-size: 14px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/ChildClip.vue